import React from 'react'
import SetDate from '../Components/SetDate/SetDate'

const SetDateView = () => {
  return (
    <div>
        <SetDate />
    </div>
  )
}

export default SetDateView